module.exports = __webpack_public_path__ + "img/mall-02.6dd3f7f2.png";